// Lightweight auth service that wraps login/logout and storage
import http from '@/api/http';
import qs from 'qs';

const TOKEN_KEY = 'auth.token';
const USER_KEY = 'auth.user';
const REMEMBERED_USERNAME_KEY = 'auth.rememberedUsername';

function saveToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

function saveUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user || null));
}

function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

function getUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function isAuthenticated() {
  return !!getToken();
}

function rememberUsername(username) {
  if (username) localStorage.setItem(REMEMBERED_USERNAME_KEY, username);
}

function getRememberedUsername() {
  return localStorage.getItem(REMEMBERED_USERNAME_KEY) || '';
}

function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

async function login({ username, password, remember }) {
  // FastAPI expects x-www-form-urlencoded fields: username, password
  // Using qs to serialize
  const data = qs.stringify({ username, password });
  const res = await http.post('/api/v1/auth/token', data, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });

  const token = res.data?.access_token;
  const user = res.data?.user;
  if (!token) throw new Error('No token returned');

  saveToken(token);
  saveUser(user);
  if (remember) rememberUsername(username);
  return { token, user };
}

function logout() {
  clearAuth();
}

export default {
  login,
  logout,
  isAuthenticated,
  getUser,
  getRememberedUsername,
};
